<template>
  <div class="m-2 flex-fill">
    <button
      :class="[
        cssClass !== null ? cssClass : null,
        styleBtnColor,
        'style-button rounded border-0',
      ]"
      :type="type"
      :disabled="disabled"
      @click="redirect"
    >
      <badge
        :quantity="quantity"
        :iconClass="iconClass"/>
    </button>
  </div>
</template>

<script>
import Badge from "@/components/Badge.vue";

export default {
  name: "BadgeButton",
  components: {
    Badge,
  },
  props: {
    cssClass: {
      type: String,
      default: null,
    },
    type: String,
    iconClass: {
      type: String,
      default: 'bi-bootstrap',
    },
    quantity: {
      type: Number,
      default: 0,
    },
    redirectURL: {
      type: String,
      default: '',
    },
  },
  computed: {
    styleBtnColor() {
      return this.quantity <= 0 ?
        'style-button-color-deactive' : 'style-button-color-active'
    },
    disabled() {
      return this.quantity <= 0 ? true : false
    }
  },
  methods: {
    redirect() {
      if (this.redirectURL) {
        this.$router.push(this.redirectURL);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.style-button {
  color: $white-color;
  height: 48px;
  width: 100%;
  transition: 0.3s;
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.25);
}
.style-button-color-active {
  background-color: $button-blue;
}
.style-button-color-deactive {
  background-color: $button-gray;
}
.style-button:hover:enabled {
  opacity: 0.8;
}
.style-button:active:enabled {
  box-shadow: 3px 2px 22px 1px rgba(134, 134, 134, 0.24);
  transform: scale(1.02, 1.02);
}
.icon-style {
  font-size: 30px;
}
</style>
